module.exports = __webpack_public_path__ + "img/background-mobile.916c9c3c.png";